import { ContractErrorModule } from '@injectivelabs/exceptions';
export const Contract = {
    ...ContractErrorModule,
};
//# sourceMappingURL=types.js.map